import { ResourcePage } from "@/components/resource-page"
import { z } from "zod"
import { Radio } from "lucide-react"

const channelSchema = z.object({
  name: z.string().min(1, "Name is required"),
  chat_id: z.string().min(1, "Chat ID is required"),
  type: z.enum(["channel", "group"]).optional(),
  is_active: z.boolean().optional(),
  admin_id: z.string().optional(),
})

const channelColumns = [
  { key: "id", type: "text", options: { label: "ID" } },
  { key: "name", type: "text", options: { label: "Name" } },
  { key: "chat_id", type: "text", options: { label: "Chat ID" } },
  { key: "type", type: "status", options: { label: "Type" } },
  { key: "is_active", type: "boolean", options: { label: "Active" } },
  { key: "admin_id", type: "text", options: { label: "Admin ID" } },
  { key: "created_at", type: "date", options: { label: "Created" } },
]

const channelFormFields = [
  { name: "name", label: "Name", type: "text", placeholder: "Enter channel name" },
  { name: "chat_id", label: "Chat ID", type: "text", placeholder: "Enter chat ID" },
  {
    name: "type",
    label: "Type",
    type: "select",
    options: [
      { value: "channel", label: "Channel" },
      { value: "group", label: "Group" },
    ],
  },
  { name: "admin_id", label: "Admin ID", type: "text", placeholder: "Enter admin ID" },
]

export default function ChannelsPage() {
  return (
    <ResourcePage
      resource="channels"
      title="Channels"
      icon={Radio}
      columns={channelColumns}
      formFields={channelFormFields}
      formSchema={channelSchema}
    />
  )
}
